module.exports = __webpack_public_path__ + "static/media/flowers_0.c8234369.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_0.csv
// module id = 747
// module chunks = 0